import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/logo-light.png';
const _withScopeId = n => (_pushScopeId("data-v-415cb201"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ck-navbar"
};
const _hoisted_2 = {
  class: "navbar-left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-menu"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Tracker",
  height: "26"
}, null, -1));
const _hoisted_6 = ["title"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-menu"
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "navbar-center d-none d-md-flex"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-search search-icon"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", {
  class: "search-kbd"
}, "⌘K", -1));
const _hoisted_12 = {
  key: 0,
  class: "ck-search-results"
};
const _hoisted_13 = {
  key: 0,
  class: "search-empty"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-search-alt me-1"
}, null, -1));
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "navbar-right"
};
const _hoisted_17 = {
  key: 2,
  class: "me-1 d-none d-lg-inline-block"
};
const _hoisted_18 = ["disabled"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-bell"
}, null, -1));
const _hoisted_20 = {
  class: "notif-panel"
};
const _hoisted_21 = {
  class: "notif-header"
};
const _hoisted_22 = {
  class: "notif-title"
};
const _hoisted_23 = {
  key: 0,
  class: "notif-count"
};
const _hoisted_24 = {
  key: 0,
  class: "notif-actions"
};
const _hoisted_25 = {
  key: 0,
  class: "notif-state"
};
const _hoisted_26 = {
  key: 1,
  class: "notif-state"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-bell-off fs-24 d-block mb-1"
}, null, -1));
const _hoisted_28 = {
  key: 2,
  class: "notif-list"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  class: "notif-avatar-wrap"
};
const _hoisted_31 = ["src", "alt"];
const _hoisted_32 = {
  key: 1,
  class: "avatar-fallback"
};
const _hoisted_33 = {
  class: "notif-body"
};
const _hoisted_34 = {
  class: "notif-msg"
};
const _hoisted_35 = {
  class: "notif-meta"
};
const _hoisted_36 = {
  class: "notif-time"
};
const _hoisted_37 = {
  key: 3,
  class: "notif-footer"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-link-external ms-1"
}, null, -1));
const _hoisted_39 = ["title"];
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-fullscreen"
}, null, -1));
const _hoisted_41 = [_hoisted_40];
const _hoisted_42 = {
  class: "nav-avatar-btn"
};
const _hoisted_43 = {
  class: "profile-panel"
};
const _hoisted_44 = {
  class: "profile-header"
};
const _hoisted_45 = {
  class: "profile-info"
};
const _hoisted_46 = {
  class: "profile-name"
};
const _hoisted_47 = {
  class: "profile-role"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-chart-areaspline me-2"
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-chart-timeline-variant me-2"
}, null, -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-account-cog-outline me-2"
}, null, -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-bell me-2"
}, null, -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-fullscreen me-2"
}, null, -1));
const _hoisted_53 = {
  class: "d-flex flex-column gap-1 py-1"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-logout me-2",
  style: {
    "color": "#f06548"
  }
}, null, -1));
const _hoisted_55 = {
  style: {
    "color": "#f06548"
  }
};
import i18n from '../i18n';
import { useStore } from 'vuex';
import usePlanPrice from '@/composable/plan-price';
import useAuth from '@/composable/auth';
import { formatNumber } from 'chart.js/helpers';
import { useRoute, useRouter } from 'vue-router';
import useNotifications from '@/composable/notifications';
import { customizeText } from '../helpers/formatter';
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import useLayouts from '@/composable/layout';
import { menuList } from '@/shared/constants/menu';
export default {
  __name: 'nav-bar',
  emits: ['mobile-toggle'],
  setup(__props, {
    emit
  }) {
    const isDarkMood = ref(false);
    const {
      toggleSidebar,
      isCollapse
    } = useLayouts();
    const store = useStore();
    const getCurrentUser = computed(() => store.getters['auth/getCurrentUser']);

    // ── Dark mode ──────────────────────────────────────────────────────────────
    const switchMode = newMode => store.dispatch('changeMode', {
      mode: newMode
    });
    function toggleDarkMode() {
      const currentTheme = document.documentElement.getAttribute('data-bs-theme');
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      isDarkMood.value = newTheme === 'dark';
      document.documentElement.setAttribute('data-bs-theme', newTheme);
      localStorage.removeItem('theme');
      localStorage.setItem('theme', newTheme);
      let htmlElement = document.querySelector('html');
      htmlElement.classList.remove('light', 'dark');
      htmlElement.classList.add(newTheme);
      switchMode({
        mode: newTheme
      });
    }

    // ── Fullscreen ─────────────────────────────────────────────────────────────
    function initFullScreen() {
      document.body.classList.toggle('fullscreen-enable');
      if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
        if (document.documentElement.requestFullscreen) document.documentElement.requestFullscreen();else if (document.documentElement.mozRequestFullScreen) document.documentElement.mozRequestFullScreen();else if (document.documentElement.webkitRequestFullscreen) document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else {
        if (document.cancelFullScreen) document.cancelFullScreen();else if (document.mozCancelFullScreen) document.mozCancelFullScreen();else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
      }
    }

    // ── Notifications ──────────────────────────────────────────────────────────
    const {
      hasUnreadMsg,
      handleReadMsg,
      handleDeleteAllNotify,
      fetchNotification,
      isNotifyLoading,
      notificationList,
      notifyUnreadCount
    } = useNotifications();
    const router = useRouter();
    const route = useRoute();
    const hasPermissions = computed(() => permission => store.getters['auth/hasPermission'](permission));
    const {
      LogoutUser
    } = useAuth();
    const {
      subscriptionRemainingDays
    } = usePlanPrice();
    async function logout() {
      await LogoutUser();
    }
    const notificationDropdown = ref(null);
    async function handleReadMessages() {
      handleReadMsg();
    }
    async function handleDeleteAll() {
      handleDeleteAllNotify();
    }
    async function handleRedirection(path, id) {
      handleReadMsg(id);
      router.push(path);
    }
    async function goToNotificationPage() {
      await router.push('/profile/notifications');
      if (notificationDropdown?.value) notificationDropdown.value.handleClose();
    }
    async function handleClickNotifications() {
      fetchNotification({
        per_page: 5
      });
    }

    // ── Global search ──────────────────────────────────────────────────────────
    const searchQuery = ref('');
    const isSearchOpen = ref(false);
    const searchInputRef = ref(null);
    const flatMenuItems = computed(() => {
      const result = [];
      const traverse = items => {
        for (const item of items) {
          if (!item) continue;
          if (item.path && item.title && !item.groupTitle && !item.isSection) {
            result.push({
              index: item.index,
              title: item.title,
              path: item.path,
              icon: item.icon || 'ri-circle-line'
            });
          }
          if (item.children) traverse(item.children);
          if (item.groupTitle && item.items) traverse(item.items);
        }
      };
      traverse(menuList);
      return result;
    });
    const searchResults = computed(() => {
      if (!searchQuery.value.trim()) return [];
      const q = searchQuery.value.toLowerCase();
      return flatMenuItems.value.filter(item => {
        const translated = i18n.global.t(item.title).toLowerCase();
        return translated.includes(q) || item.title.toLowerCase().includes(q);
      }).slice(0, 8);
    });
    function closeSearch() {
      isSearchOpen.value = false;
      searchQuery.value = '';
    }
    function openSearch() {
      isSearchOpen.value = true;
      nextTick(() => searchInputRef.value?.focus());
    }
    function navigateTo(path) {
      router.push(path);
      closeSearch();
    }
    function handleGlobalKeydown(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        openSearch();
      }
      if (e.key === 'Escape') closeSearch();
    }
    onMounted(() => {
      isDarkMood.value = localStorage.getItem('theme') === 'dark';
      window.addEventListener('keydown', handleGlobalKeydown);
    });
    onUnmounted(() => {
      window.removeEventListener('keydown', handleGlobalKeydown);
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_b_spinner = _resolveComponent("b-spinner");
      const _component_b_badge = _resolveComponent("b-badge");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _directive_click_outside = _resolveDirective("click-outside");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
        class: "nav-icon-btn d-md-none",
        onClick: _cache[0] || (_cache[0] = $event => emit('mobile-toggle'))
      }, _hoisted_4), _createVNode(_component_router_link, {
        class: "mobile-logo d-md-none",
        to: "/dashboard"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createElementVNode("button", {
        class: "nav-icon-btn d-none d-md-flex",
        onClick: _cache[1] || (_cache[1] = $event => _unref(toggleSidebar)(!_unref(isCollapse))),
        title: _unref(isCollapse) ? 'Expand' : 'Collapse'
      }, _hoisted_8, 8, _hoisted_6)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
        class: _normalizeClass(["ck-search", {
          focused: isSearchOpen.value
        }])
      }, [_createElementVNode("div", {
        class: "ck-search-trigger",
        onClick: openSearch
      }, [_hoisted_10, _withDirectives(_createElementVNode("input", {
        ref_key: "searchInputRef",
        ref: searchInputRef,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchQuery.value = $event),
        class: "ck-search-input",
        placeholder: "Search...",
        onFocus: _cache[3] || (_cache[3] = $event => isSearchOpen.value = true)
      }, null, 544), [[_vModelText, searchQuery.value]]), _hoisted_11]), isSearchOpen.value && searchQuery.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [!searchResults.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createTextVNode(" No results for \"" + _toDisplayString(searchQuery.value) + "\" ", 1)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, result => {
        return _openBlock(), _createElementBlock("div", {
          key: result.index,
          class: "search-result-item",
          onClick: $event => navigateTo(result.path)
        }, [_createElementVNode("i", {
          class: _normalizeClass([result.icon, "result-icon"])
        }, null, 2), _createElementVNode("span", null, _toDisplayString(_ctx.$t(result.title)), 1)], 8, _hoisted_15);
      }), 128))])) : _createCommentVNode("", true)], 2)])), [[_directive_click_outside, closeSearch]]), _createElementVNode("div", _hoisted_16, [getCurrentUser.value?.delegatee?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        class: "me-1 d-none d-lg-inline-flex",
        type: "warning",
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegatee')) + ": " + _toDisplayString(getCurrentUser.value?.delegatee?.fullname?.split(' ')[0]), 1)]),
        _: 1
      })) : _createCommentVNode("", true), getCurrentUser.value?.delegator?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        class: "me-1 d-none d-lg-inline-flex",
        type: "success",
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegator')) + ": " + _toDisplayString(getCurrentUser.value?.delegator?.fullname?.split(' ')[0]), 1)]),
        _: 1
      })) : _createCommentVNode("", true), hasPermissions.value('subscription-list-request') ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_tag, {
        type: _unref(subscriptionRemainingDays) > 4 ? 'info' : 'danger',
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.subscription')) + ": " + _toDisplayString(_unref(subscriptionRemainingDays)) + "d ", 1)]),
        _: 1
      }, 8, ["type"])])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
        ref_key: "notificationDropdown",
        ref: notificationDropdown,
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("h6", _hoisted_22, [_createTextVNode(_toDisplayString(_ctx.$t('notifications.notification')) + " ", 1), _unref(notifyUnreadCount) ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(" + _toDisplayString(_unref(formatNumber)(_unref(notifyUnreadCount))) + ")", 1)) : _createCommentVNode("", true)]), !_unref(isNotifyLoading) && _unref(notificationList)?.data?.length ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_el_tooltip, {
          content: _ctx.$t('notifications.clearAll'),
          placement: "top",
          effect: "light"
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: "ri-delete-bin-line",
            onClick: handleDeleteAll
          })]),
          _: 1
        }, 8, ["content"]), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('notifications.markAllAsRead'),
          placement: "top",
          effect: "light"
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: "ri-checkbox-circle-line",
            onClick: handleReadMessages
          })]),
          _: 1
        }, 8, ["content"])])) : _createCommentVNode("", true)]), _unref(isNotifyLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_b_spinner, {
          type: "grow",
          variant: "info",
          label: "Loading"
        })])) : !_unref(notificationList)?.data?.length ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createTextVNode(" " + _toDisplayString(_ctx.$t('notifications.noNotificationFound')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationList)?.data, notify => {
          return _openBlock(), _createElementBlock("div", {
            key: notify.id,
            class: _normalizeClass(["notif-item", {
              unread: !notify.is_read
            }]),
            onClick: $event => handleRedirection(notify?.data?.path, notify?.id)
          }, [_createElementVNode("div", _hoisted_30, [notify.data?.sender?.image ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: notify.data?.sender?.image,
            alt: notify.data?.sender?.fullname,
            class: "avatar-xs rounded-circle"
          }, null, 8, _hoisted_31)) : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(notify.data?.sender?.fullname?.charAt(0) || '?'), 1))]), _createElementVNode("div", _hoisted_33, [_createElementVNode("p", _hoisted_34, _toDisplayString(notify.data.message), 1), _createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(notify?.created_at), 1), _createVNode(_component_b_badge, {
            class: "bg-secondary-subtle text-secondary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(customizeText)(notify?.data?.group) || '-'), 1)]),
            _: 2
          }, 1024)])])], 10, _hoisted_29);
        }), 128))])), _unref(notificationList)?.data?.length ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: goToNotificationPage
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('notifications.viewAllNotifications')) + " ", 1), _hoisted_38]),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createElementVNode("button", {
          disabled: _unref(route)?.path === '/profile/notifications',
          class: "nav-icon-btn",
          onClick: handleClickNotifications
        }, [_createVNode(_component_el_badge, {
          hidden: _unref(notifyUnreadCount) < 1,
          max: 99,
          value: _unref(notifyUnreadCount)
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 1
        }, 8, ["hidden", "value"])], 8, _hoisted_18)]),
        _: 1
      }, 512), _createElementVNode("button", {
        class: "nav-icon-btn d-none d-md-flex",
        onClick: toggleDarkMode,
        title: isDarkMood.value ? 'Light mode' : 'Dark mode'
      }, [_createElementVNode("i", {
        class: _normalizeClass(isDarkMood.value ? 'ri-sun-line' : 'bx bx-moon')
      }, null, 2)], 8, _hoisted_39), _createElementVNode("button", {
        class: "nav-icon-btn d-none d-md-flex",
        onClick: initFullScreen,
        title: "Fullscreen"
      }, _hoisted_41), _createVNode(_component_el_dropdown, {
        size: "large",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_el_image, {
          src: getCurrentUser.value.image,
          alt: "avatar",
          class: "profile-avatar rounded-circle"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString(getCurrentUser.value.fullname), 1), _createElementVNode("span", _hoisted_47, _toDisplayString(getCurrentUser.value.position), 1)])]), _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[4] || (_cache[4] = $event => _unref(router).push('/profile/overview'))
          }, {
            default: _withCtx(() => [_hoisted_48, _createTextVNode(_toDisplayString(_ctx.$t('common.overview')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[5] || (_cache[5] = $event => _unref(router).push('/profile/performance'))
          }, {
            default: _withCtx(() => [_hoisted_49, _createTextVNode(_toDisplayString(_ctx.$t('task.userAnalytics')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[6] || (_cache[6] = $event => _unref(router).push('/profile/editProfile'))
          }, {
            default: _withCtx(() => [_hoisted_50, _createTextVNode(_toDisplayString(_ctx.$t('profile.editProfile')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[7] || (_cache[7] = $event => _unref(router).push({
              name: 'notifications-settings'
            }))
          }, {
            default: _withCtx(() => [_hoisted_51, _createTextVNode(_toDisplayString(_ctx.$t('notifications.notificationSetting')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: toggleDarkMode
          }, {
            default: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass([isDarkMood.value ? 'ri-sun-line' : 'bx bx-moon', "me-2"])
            }, null, 2), _createTextVNode(_toDisplayString(_ctx.$t('header.theme')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            class: "d-lg-none",
            onClick: initFullScreen
          }, {
            default: _withCtx(() => [_hoisted_52, _createTextVNode("Fullscreen ")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            class: "d-lg-none",
            onClick: _cache[8] || (_cache[8] = $event => _unref(router).push({
              name: 'subscription'
            }))
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [getCurrentUser.value?.delegatee?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "warning",
              size: "small"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegatee')) + ": " + _toDisplayString(getCurrentUser.value?.delegatee?.fullname?.split(' ')[0]), 1)]),
              _: 1
            })) : _createCommentVNode("", true), getCurrentUser.value?.delegator?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "success",
              size: "small"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegator')) + ": " + _toDisplayString(getCurrentUser.value?.delegator?.fullname?.split(' ')[0]), 1)]),
              _: 1
            })) : _createCommentVNode("", true), hasPermissions.value('subscription-list-request') ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 2,
              type: _unref(subscriptionRemainingDays) > 4 ? 'primary' : 'danger',
              size: "small"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.subscription')) + ": " + _toDisplayString(_unref(subscriptionRemainingDays)) + " " + _toDisplayString(_ctx.$t('header.daysRemaining')), 1)]),
              _: 1
            }, 8, ["type"])) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: _cache[9] || (_cache[9] = $event => logout())
          }, {
            default: _withCtx(() => [_hoisted_54, _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('header.logout')), 1)]),
            _: 1
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("button", _hoisted_42, [_createVNode(_component_el_image, {
          src: getCurrentUser.value.image,
          alt: "avatar",
          class: "rounded-circle",
          style: {
            "width": "32px",
            "height": "32px"
          }
        }, null, 8, ["src"])])]),
        _: 1
      })])]);
    };
  }
};